import { UsersDto } from "users-experience-client";
import { createUsersApi } from "../api-helpers/UserApiHelper";
import { GridDropdown } from "./GridDropdown";
import { UserContextHolder } from "../auth/UserContextHolder";
import { Constants } from "../constants/Lookups";
import { useNavigate } from "react-router-dom";

export interface Props {
  label?: string;
  initialUserIds?: string[];
  onChange: (selection: UsersDto[]) => void;
}

export const GridUsersDropdown = ({ label, initialUserIds, onChange }: Props) => {
  const usersApi = createUsersApi();

  const loadData = async (searchText?: string): Promise<UsersDto[]> => {
    const { data } = await usersApi.usersControllerFindAll();
    
    if (Array.isArray(data)) {
      const users: UsersDto[] = data.sort((user1, user2) => getName(user1).localeCompare(getName(user2)));
      if (window.location.pathname === '/patients' || window.location.pathname === '/eligible-patients') {
        users.push({
          id: Constants.NOT_SET,
          firstName: Constants.NOT_SET,
          lastName: ""
        } as UsersDto)
      }
    const currentUser = users.find(user => user.id === UserContextHolder.getUser()?.id);
    currentUser!.firstName = "Me";
    currentUser!.lastName = "";
    return currentUser ? [currentUser, ...users.filter(user => user.id !== UserContextHolder.getUser()?.id)] : users;
    }
    else{
      return []; // Return an empty array or handle the error as needed
    }
    
    
      
  };

  return (
    <GridDropdown
      label={label ?? "Select User"}
      keyProvider={user => user.id}
      labelProvider={user => getName(user)}
      dataProvider={loadData}
      initialKeys={initialUserIds}
      onChange={onChange}
      ></GridDropdown>
  );
};

function getName(user: UsersDto): string {
  return user.firstName + " " + user.lastName;
}
